import { render, staticRenderFns } from "./SOCScreen2.vue?vue&type=template&id=5d5b648b&"
import script from "./SOCScreen2.vue?vue&type=script&lang=js&"
export * from "./SOCScreen2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports